import { useGroupListFilter, useSetGroupListFilter } from '@gripp/shared-logic';
import {
  countFilters,
  FilterHeaders,
  GroupSearchInput,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { GroupsToolbar } from './groupsToolbar';

export const GroupsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: groupFilter } = useGroupListFilter();
  const { mutateAsync: setGroupListFilter } = useSetGroupListFilter();
  const filterCount = countFilters(groupFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/groups/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={groupFilter?.keyword}
        searchComponent={<GroupSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() =>
          setGroupListFilter({ ...groupFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />
      <GroupsToolbar />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
});
